document.addEventListener('DOMContentLoaded', (e) => {
    jQuery('.slider').slick({
        arrows: false,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true
    });
});